var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentFile,{tag:"component",attrs:{"color":_vm.color,"fill":_vm.fill,"stroke":_vm.stroke,"width":_vm.width,"height":_vm.height,"view-box":`0 0 ${_vm.width} ${_vm.height}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }